import { inject, Injectable } from '@angular/core';
import { DetailsService } from 'src/app/pages/new-details/new-details.service';
import { detailsAdapter } from 'src/app/pages/new-details/new-details.adapter';
import { IndicatorsService } from 'src/app/pages/custom-route/shared/map/services/indicators.service';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { catchError, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';

export type ItemType = 'point' | 'event';
export interface ItemPayload {
  element_id: string;
  type: ItemType;
  operation_id?: string;
  completion_id?: string;
}

export interface ItemDetailsResult {
  is_successful: boolean;
  reason?: string;
}

@Injectable({ providedIn: 'root' })

export class ShowItemDetailsService {
  private _detailsService = inject(DetailsService);
  private _indicatorsService = inject(IndicatorsService);
  private _breakpointsService = inject(BreakpointsService);  

  show(item: ItemPayload) {
    if (!item?.element_id) 
      return of<ItemDetailsResult>({ is_successful: false, reason: 'No se ha especificado id del elemento' });
    
    if (!['point', 'event'].includes(item.type)) 
      return of<ItemDetailsResult>({ is_successful: false, reason: 'Tipo debe ser "point" o "event"' });

    const req$ = item.type === 'point'
      ? this._detailsService.getPointDetails(item.element_id)
      : this._detailsService.getEventDetails(item.element_id);

    return req$.pipe(
      map(resp => detailsAdapter(resp)),
      tap(async adapted => {
        if (item.type === 'point') 
            this._detailsService.setPointData(adapted);
        else 
            this._detailsService.setEventData(adapted);

        if (this._breakpointsService.isMobile())
          await this._indicatorsService.openBottomSheetDetailsMobile(adapted);
        else 
          await this._indicatorsService.openDialogDetailsDesktop(adapted);

      }),
      map(() => ({ is_successful: true } as ItemDetailsResult)),
      catchError(() => of({ 
        is_successful: false, 
        reason: 'No se ha encontrado el punto o evento' 
      }))
    );
  }
}